var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>-1.5</li> '+
                            '<li>+1.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>-2.5</li> '+
                            '<li>+2.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>-3.5</li> '+
                            '<li>+3.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>-4.5</li> '+
                            '<li>+4.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="-1.5" data-betCode="314" class="bet-choose" data-odd="'+quotes.Under15+'">'+globalFunctions.checkQuotes(quotes.Under15)+'</li> '+
                                '<li data-betType="+1.5" data-betCode="316" class="bet-choose" data-odd="'+quotes.Over15+'">'+globalFunctions.checkQuotes(quotes.Over15)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="-2.5" data-betCode="324" class="bet-choose" data-odd="'+quotes.Under25+'">'+globalFunctions.checkQuotes(quotes.Under25)+'</li> '+
                                '<li data-betType="+2.5" data-betCode="326" class="bet-choose" data-odd="'+quotes.Over25+'">'+globalFunctions.checkQuotes(quotes.Over25)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="-3.5" data-betCode="334" class="bet-choose" data-odd="'+quotes.Under35+'">'+globalFunctions.checkQuotes(quotes.Under35)+'</li> '+
                                '<li data-betType="+3.5" data-betCode="336" class="bet-choose" data-odd="'+quotes.Over35+'">'+globalFunctions.checkQuotes(quotes.Over35)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="-4.5" data-betCode="344" class="bet-choose" data-odd="'+quotes.Under45+'">'+globalFunctions.checkQuotes(quotes.Under45)+'</li> '+
                                '<li data-betType="+4.5" data-betCode="346" class="bet-choose" data-odd="'+quotes.Over45+'">'+globalFunctions.checkQuotes(quotes.Over45)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/under_over.js
// module id = 2006
// module chunks = 4